import "./Why01.css";
import img from "./../../../img/cont/why-us.webp";

import star from "./../../../img/icons/star.svg";
import doc2 from "./../../../img/icons/doc.svg";
import hands from "./../../../img/icons/hands.svg";

function Why01() {
  return (
    <div className="Why01 section">
      <div className="container">
        <div className="Why01-box">
          <img src={img} alt="" />

          <div>
            <p className="eyebrow green">Why Us? </p>
            <h2>Service & Certainty You Can Rely On</h2>
            <p>
              Choosing the right waste management partner is crucial for your
              business's reputation and compliance. Here’s why we are the
              industry leader.
            </p>

            <div className="Why01-list-item">
              <div className="Why01-list-icon">
                <img src={star} alt="" />
              </div>
              <div className="Why01-list-text">
                <h4>Excellent Customer Service</h4>
                <p>
                  Dedicated support for easy scheduling and clear communication.{" "}
                </p>
              </div>
            </div>
            <div className="Why01-list-item">
              <div className="Why01-list-icon">
                <img src={doc2} alt="" />
              </div>
              <div className="Why01-list-text">
                <h4>Guaranteed Compliance</h4>
                <p>
                  Fully licensed for guaranteed compliance and peace of mind.
                </p>
              </div>
            </div>
            <div className="Why01-list-item">
              <div className="Why01-list-icon">
                <img src={hands} alt="" />
              </div>
              <div className="Why01-list-text">
                <h4>Transparent Partnership</h4>
                <p>
                  Get clear pricing and flexible scheduling from a reliable
                  partner.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Why01;
